import { ReactSortable } from 'react-sortablejs';
import { Button } from 'tea-component';
import { PlusOutlined } from '@ant-design/icons';
import React, { useMemo } from 'react';
import type { IColumnInfo } from '@dbl/core/dataSource';
import { useFilterHandle } from './useFilterHandle';
import { LogicAndOr } from '../widgets/LogicAndOr';
import { FilterItem } from './filter_item';
import { getFirstColumn, getFlatOptions } from '../../utils';
import {deepClone, useDblIntl} from '@/pages/datalab/utils/utils';
import SvgIcon from '@/pages/home/components/SvgIcon';

export function FilterEdit(props: {
  columns: IColumnInfo[];
  filterLogic: number;
  allFilters: any[];
  optionFilters: any[];
  dispatchFun: Function;
  hideAddItemBtn?: boolean;
}) {
  const { columns, filterLogic, allFilters, optionFilters, dispatchFun, hideAddItemBtn } = props;
  const notifyFun = (columnFilters: IColumnInfo[]) => {
    dispatchFun({
      payload: { columnFilters },
    });
  };
  const { dblFormatMessage: explorationFormatMessage} = useDblIntl("exploration");
  const handle = useFilterHandle(columns, notifyFun);
  const { addItem, setItems } = handle;
  const selectedItems = useMemo(() => columns.map((item) => item.column_name), [JSON.stringify(columns)]);
  return (
    <>
      <div className="model-port">
        <div className="indicators-all-context">
          {columns.length >= 2 || hideAddItemBtn ? (
            <LogicAndOr
              value={filterLogic}
              columnCount={columns.length}
              onChange={(value) => {
                dispatchFun({
                  payload: { filterLogic: value },
                });
              }}
            />
          ) : (
            <></>
          )}

          <div className="context-right">
            <ReactSortable<any>
              list={columns}
              setList={(list: IColumnInfo[]) => {
                setItems(list);
              }}
            >
              {columns.map((column) => (
                <FilterItem
                  key={`${column.table_id}.${column.column_name}`}
                  column={column}
                  optionFilters={optionFilters}
                  handle={handle}
                  selectedItems={selectedItems}
                  onSelectItem={(newItemName: string) => {
                    const newColumn = allFilters.find((item: IColumnInfo) => item.column_name === newItemName);
                    if (!newColumn || newColumn.column_name === column.column_name) {
                      return;
                    }
                    const position = columns.indexOf(column);
                    if (position < 0) {
                      return;
                    }
                    const list = [
                      ...columns.slice(0, position),
                      { ...deepClone(newColumn) },
                      ...columns.slice(position + 1, columns.length),
                    ];
                    setItems(list);
                  }}
                />
              ))}
            </ReactSortable>
          </div>
        </div>
      </div>
      <span
        className="add-box"
        style={{ display: `${hideAddItemBtn ? 'none' : ''}` }}
        onClick={() => {
          const flatOptions = getFlatOptions(optionFilters);
          const newColumn = getFirstColumn(allFilters, columns, flatOptions);
          if (!newColumn) {
            return;
          }
          addItem(newColumn);
        }}
      >
        <SvgIcon type="add-bg-icon" className="add-box-icon" />
        <span className="add-box-text">{explorationFormatMessage("add_filter")}</span>
      </span>
    </>
  );
}
